import { render, staticRenderFns } from "./SidebarSuperAdmin.vue?vue&type=template&id=b74a29b2&scoped=true&"
import script from "./SidebarSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarSuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSuperAdmin.vue?vue&type=style&index=0&id=b74a29b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74a29b2",
  null
  
)

export default component.exports